var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable, makeObservable } from 'mobx';
import { AspectMount } from './AspectMount';
import { runtime } from '../../../runtime/Runtime';
export class AspectMounts {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get aspect() {
        return this.parent;
    }
    mounts = new Map();
    observableMounts = observable.map();
    getMountForComponent(reactInstance) {
        let mount = this.mounts.get(reactInstance);
        if (!mount) {
            mount = new AspectMount(this.aspect, reactInstance);
            this.mounts.set(reactInstance, mount);
            runtime.runtimeScheduler.addToNextIdleStateChange(() => this.observableMounts.set(reactInstance, mount));
        }
        return mount;
    }
    mountAspect(reactInstance) {
        runtime.runtimeScheduler.addToNextIdleStateChange(() => {
            this.aspect.context.stage.stageMountedAspects.mountedAspects.push(this.aspect);
        });
    }
    unMountAspect(reactInstance) {
        this.mounts.delete(reactInstance);
        runtime.runtimeScheduler.addToNextIdleStateChange(() => {
            this.observableMounts.delete(reactInstance);
            if (this.observableMounts.size === 0) {
                this.aspect.context.stage.stageMountedAspects.mountedAspects.remove(this.aspect);
            }
        });
    }
    get isAspectMounted() {
        return this.observableMounts.size > 0; //  && this.mounts.size > 0;
    }
}
__decorate([
    observable.shallow
], AspectMounts.prototype, "observableMounts", void 0);
__decorate([
    action.bound
], AspectMounts.prototype, "mountAspect", null);
__decorate([
    action.bound
], AspectMounts.prototype, "unMountAspect", null);
